import { MultiLanguageTextModel } from './MultiLanguageTextModel';
import { PartnerModel } from './PartnerModel';

export class SponsorModel extends PartnerModel {
  private _zeppelinImage: string;

  constructor(
    id: string,
    name: string,
    websiteUrl: string,
    description: MultiLanguageTextModel,
    logo: string,

    email: string | null,
    phone: string | null,
    address: string | null,
    htmlDescription: string | null = null,
    zeppelinImage: string
  ) {
    super(
      id,
      name,
      websiteUrl,
      description,
      logo,
      email,
      phone,
      address,
      htmlDescription
    );
    this._zeppelinImage = zeppelinImage;
  }

  get zeppelinImage() {
    return this._zeppelinImage;
  }
}
